import { RouteObject } from 'react-router-dom';
import UnauthenticatedRoot from '@/portal/routes/UnauthenticatedRoot.tsx';
import { unauthenticatedRoutes } from '@/portal/unauthenticatedRoutes.tsx';
import AuthenticatedRoot from '@/portal/routes/AuthenticatedRoot.tsx';
import { authenticatedRoutes } from '@/portal/authenticatedRoutes.tsx';
import { loader as authenticatedLoader } from '@/portal/routes/AuthenticatedLoader.ts';
import ErrorBoundary from '@/common/components/ErrorBoundary.tsx';

export const createPortalRoutes = (): RouteObject[] => [
  {
    id: 'portal-unauthenticated',
    path: '/portal',
    element: <UnauthenticatedRoot />,
    children: unauthenticatedRoutes,
    errorElement: <ErrorBoundary />,
  },
  {
    id: 'portal-authenticated',
    path: '/portal',
    element: <AuthenticatedRoot />,
    children: authenticatedRoutes,
    loader: authenticatedLoader,
    errorElement: <ErrorBoundary />,
  },
];
